import { ParamsProps, ReturnType } from '@apis/types'
import request from '@utils/request'

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'configs',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
      cacheTTL: 600000, // 10 minutes
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default { list }
